import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AuthenticationService, SocialLoginService} from '../../_services';
import {Constants} from '../../shared/Helpers/constants';
import {SharedService} from '../../shared/shared.service';
import { SocialProviderNameEnum } from 'src/app/enums/enums';

@Component({
  selector: 'app-google-callback',
  templateUrl: './google-callback.component.html'
})
export class GoogleCallbackComponent implements OnInit {

  public logoPath: any = null;
  public linkCheckErrorMessage: string | any = null;
  public showHeader: boolean = false;

  constructor(
    private route: ActivatedRoute,
    public authenticationService: AuthenticationService,
    private socialLoginService: SocialLoginService,
    private router: Router,
    public sharedService: SharedService
  ) {
  }

  ngOnInit() {
    let code: any;
    let state: any;
    this.route.queryParams.subscribe((res: Params) => {
      code = res.code;
      state = res.state;
    });

    this.socialLoginService.getSocialInvitationSignUpOAuthCallback(SocialProviderNameEnum.Google, code, state).subscribe({
      next: (res) => {
        if (res) {
          this.router.navigate(['login/oauth/connect/google'], {queryParams: {signUp: 1}});
        }
      },
      error: (err) => {
        this.linkCheckErrorMessage = err.error.detailedMessage;
        if (this.linkCheckErrorMessage.includes('The Google account you have tried')) {
          this.showHeader = true;
        }
      }
    });
  }

  ngDoCheck() {
    if (this.sharedService.loadedOrganisationByUrl.value) {
      if (this.sharedService.loginCustomisation.value != undefined && this.sharedService.loginCustomisation.value != null) {
        if (this.sharedService.LogoImage.value != null) {
          this.logoPath = null;
          this.logoPath = this.sharedService.LogoImage.value;
        } else {
          this.logoPath = Constants.logoPath;
        }
      } else {
        this.logoPath = Constants.logoPath;
      }
    } else {
      this.logoPath = Constants.logoPath;
    }
  }

}
